import {
  shouldSendOnEnter,
  type ComposerEnterKeyEvent,
} from '@/lib/composer-enter-key';

import type { MarketingComposerExample } from './marketing-page-content-types';

export function selectMarketingComposerExample(
  currentDraft: string,
  example: MarketingComposerExample
): string {
  return currentDraft === example.prompt ? '' : example.prompt;
}

export function shouldSubmitMarketingComposer(
  event: ComposerEnterKeyEvent,
  touchPrimary?: boolean
): boolean {
  return shouldSendOnEnter(event, touchPrimary);
}

export function hasMarketingComposerDraft(draft: string): boolean {
  return draft.trim().length > 0;
}
